import { call, put, take, takeLatest } from "redux-saga/effects";
import {
  DISTRIBUTOR_CONTACT_DETAILS,
  REGISTER_DISTRIBUTOR_DETAILS,
  UPLOAD_DRUG_LICENCE,
  UPLOAD_GST_CERTIFICATE,
} from "../actions/types";
import * as onBoardingApis from "../apis/onBoardingApis";

export function* registerDetailsWorker(action) {
  try {
    const res = yield call(
      onBoardingApis.registerDistributorDetailsApi,
      action.data
    );
    if (res.status == 200) {
      yield action.onSuccess(res);
      console.log(res.data.data);
      localStorage.setItem(
        "isEmailVerified",
        res.data.data.email_verified
      );
      localStorage.setItem(
        "isDetails",
        res.data.data.is_details
      );
      localStorage.setItem(
        "isContactDetails",
        res.data.data.is_contact_details
      );
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      "data": {
        message: "Something went wrong"
      }
    })
  }
}

export function* uploadGstWorker(action) {
  try {
    const file = new FormData();
    file.append("file", action.image);
    const res = yield call(onBoardingApis.uploadGSTCertificateApi, file);
    console.log(res);
    if (res.status == 200) {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      "data": {
        message: "Something went wrong"
      }
    })
  }
}

export function* uploadDrugLicenceWorker(action) {
  try {
    const file = new FormData();
    file.append("file", action.image);
    const res = yield call(onBoardingApis.uploadDrugLicenceApi, file);
    console.log(res);
    if (res.status == 200) {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      "data": {
        message: "Something went wrong"
      }
    })
  }
}

export function* contactDetailWorker(action) {
  try {
    const res = yield call(
      onBoardingApis.registerDistributorContactDetailApi,
      action.data
    );
    if (res.status == 200) {
      yield action.onSuccess(res);
      localStorage.setItem(
        "isEmailVerified",
        res.data.data.email_verified
      );
      localStorage.setItem(
        "isDetails",
        res.data.data.is_details
      );
      localStorage.setItem(
        "isContactDetails",
        res.data.data.is_contact_details
      );
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      "data": {
        message: "Something went wrong"
      }
    })
  }
}

export function* registerDetailsWatcher() {
  yield takeLatest(REGISTER_DISTRIBUTOR_DETAILS, registerDetailsWorker);
}

export function* uploadGstWatcher() {
  yield takeLatest(UPLOAD_GST_CERTIFICATE, uploadGstWorker);
}

export function* uploadDrugLicenceWatcher() {
  yield takeLatest(UPLOAD_DRUG_LICENCE, uploadDrugLicenceWorker);
}

export function* contactDetailsWorker() {
  yield takeLatest(DISTRIBUTOR_CONTACT_DETAILS, contactDetailWorker);
}
